import React from "react";

import {
  ForwardToInboxRounded,
  VisibilityOffRounded,
  VisibilityRounded,
} from "@mui/icons-material";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import { Box, TextField } from "@mui/material";

import useAuth from "../../../config/context/authContext";
import useModal from "../../../config/context/modalContext";
import { GreyPallet } from "../../../config/styles";
import firebaseError from "../../../config/util/firebaseError";

import MainLinkButton from "../../../components/MainLinkButton";
import MainSolidButton from "../../../components/MainSolidButton";
import MainText from "../../../components/MainText";

import { AvailableFormOptions } from "..";
import MainBorderButton from "../../../components/MainBorderButton";
import useFirebase from "../../../config/context/firebaseContext";
import { sendPasswordResetEmail } from "firebase/auth";
import { Dev } from "../../../config/util/consoleUtil";

interface ComponentProps {
  setFormOption: (option: AvailableFormOptions) => void;
}

export default function ResetPasswordForm({ setFormOption }: ComponentProps) {
  const { auth } = useFirebase();

  const { pushAlert } = useModal();

  const [loading, setLoading] = React.useState(false);

  const [emailField, setEmailField] = React.useState("");

  const handleReset = async () => {
    try {
      setLoading(true);

      await sendPasswordResetEmail(auth, emailField);

      pushAlert({
        type: "success",
        message: "Email enviado. ",
      });

      setFormOption(AvailableFormOptions.login);
    } catch (error) {
      console.log(...new Dev("handleReset", error).Error());

      pushAlert({
        type: "error",
        message: "Erro ao enviar email. " + firebaseError(error),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }} style={{ backgroundColor: GreyPallet.Light, borderRadius: 15 }}>
      <MainText color="regular">
        Nós enviaremos um link de redefinição de senha para este email.
      </MainText>

      <Box mt={2}>
        <TextField
          fullWidth
          type="email"
          inputMode="email"
          label="Email"
          variant="outlined"
          sx={{
            "& .MuiFormLabel-root": {
              fontWeight: "bold",
              color: `${GreyPallet.Regular} !important`,
            },

            "& .MuiOutlinedInput-root": {
              borderRadius: "15px",
              height: 60,
            },

            "& .MuiInputBase-input": {
              fontWeight: "bold",
              fontSize: 16,
              color: GreyPallet.Regular,
            },

            "& .MuiSvgIcon-root": {
              fontSize: 26,
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderWidth: "3px !important",
              borderColor: `${GreyPallet.Regular} !important`,
              borderStyle: "solid",
              "& .Mui-focused": {
                borderColor: `${GreyPallet.Regular} !important`,
              },
            },
          }}
          value={emailField}
          onChange={(e) => setEmailField(e.target.value)}
        />
      </Box>

      <Box mt={3}>
        <MainSolidButton
          loading={loading}
          text="Enviar"
          icon={<ForwardToInboxRounded />}
          onClick={handleReset}
        />
      </Box>

      <Box mt={2}>
        <MainLinkButton text="Voltar" onClick={() => setFormOption(AvailableFormOptions.login)} />
      </Box>
    </Box>
  );
}
